export const defaultFilters = {
  page: 1,
  perPage: 10,
  pageSize: 10
}

export const camelToSnake = (str?: string) =>
  str ? str.replace(/([A-Z])/g, '_$1').toLowerCase() : ''

export const snakeToCamel = (str?: string) =>
  str ? str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()) : ''
